<template>
  <v-container>
    <alerts
      module="cart"
    />

    <product-items-loading v-if="loading" />
    <template
      v-else
    >
      <template v-if="filteredPackages.length > 0">
        <h2 class="ma-3">Packages</h2>
        <v-data-iterator
          :items="filteredPackages"
          itemKey="id"
          :itemsPerPage="20"
          hideDefaultFooter
        >
          <template v-slot:default="{ items }">
            <v-row>
              <v-col
                v-for="item in items"
                cols="12"
                sm="6"
                :key="item.id"
              >
                <v-card v-if="item.priceSettings">
                  <v-card-title class="text-wrap">{{ item.name }}</v-card-title>
                  <v-card-subtitle class="pb-0">{{ item.description }}</v-card-subtitle>
                  <v-card-text class="pb-0">
                    <v-list>
                      <v-list-item v-for="(quantity, programId) in item.programs" :key="programId">
                        <v-list-item-title>{{ getProgramName(programId) }}</v-list-item-title>
                        <v-list-item-subtitle>{{ quantity }}</v-list-item-subtitle>
                      </v-list-item>
                    </v-list>
                  </v-card-text>
                  <v-card-actions>
                    <the-price :price="item.priceSettings.price" />

                    <v-spacer />
                    <v-btn
                      dark
                      rounded
                      color="green"
                      @click="addToCart(item)"
                    >
                      <v-icon>mdi-cart-plus</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </template>
        </v-data-iterator>
      </template>
      <template v-if="showALaCarte">
        <h2 class="ma-3 mt-10">A la Carte Visits</h2>
        <v-data-iterator
          :items="aLaCartVisits"
          itemKey="id"
          :itemsPerPage="20"
          hideDefaultFooter
        >
          <template v-slot:default="{ items }">
            <v-row>
              <v-col
                v-for="item in items"
                cols="12"
                sm="6"
                md="4"
                lg="3"
                :key="item.id"
              >
                <v-card v-if="item.priceSettings && item.priceSettings.aLaCarteEnabled">
                  <v-card-title class="text-wrap">{{ item.name }}</v-card-title>
                  <v-card-subtitle>{{ item.description }}</v-card-subtitle>
                  <v-card-actions>
                    <the-price :price="item.priceSettings.price" />

                    <v-spacer />
                    <the-quantity v-model="item.quantity" />
                    <v-btn
                      dark
                      rounded
                      color="green"
                      @click="addToCart(item)"
                    >
                      <v-icon>mdi-cart-plus</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </template>

        </v-data-iterator>
      </template>

      <v-alert v-else-if="visitManagementDisabled" type="warning">You can request more visits from your organization manager.</v-alert>
    </template>
  </v-container>
</template>
<script>
import ThePrice from '@/components/utilities/thePrice.vue';
import TheQuantity from '@/components/utilities/theQuantity.vue';
import ProductItemsLoading from './utilities/productItemsLoading.vue';
import { mapState } from 'vuex';

export default {
  name: 'TheProducts',
  components: {
    ThePrice,
    TheQuantity,
    ProductItemsLoading
  },
  data: function () {
    return {
      thing: 1,
      selectedProduct: null,
      selectedVariation: null
    };
  },
  methods: {
    addToCart: function (item) {
      this.$store.commit('cart/addItem', item);
    },
    getProgramName: function (id) {
      const program = this.programs.find(program => program.id === id);
      if (program) {
        return program.name;
      }
      return '';
    }
  },
  computed: {
    filteredPackages: function () {
      return this.packages.filter(pckage => pckage.priceSettings);
    },
    aLaCartVisits: function () {
      return this.programs.filter(program => program.priceSettings?.aLaCarteEnabled);
    },
    visitManagementDisabled: function () {
      return !(this.showALaCarte && this.packages?.length > 0);
    },
    showALaCarte: function () {
      return this.aLaCartVisits.length > 0;
    },
    ...mapState(['packages', 'programs', 'loading'])
  },
  created: function () {
    this.$store.dispatch('getOrganization');
  }
};
</script>
